﻿import {UserGroup} from "../user-group/user-group";

export class ContragentScUserGroup {
	serviceCenterPerformerGroupId?: number;
	serviceCenterId: number;
	userGroupId: number;
	userGroup: UserGroup = new UserGroup();
}
